const getters = {
  // 当前切换的园区ID
  gardenId: state => state.user.gardenId,
  groupId: state => state.user.groupId,
  theme: state => state.theme.theme,
  themeColor: state => state.theme.themeColor,
  tabList: state => state.tab.tabList,
  // 用户信息
  userData: state => state.user.userData,
  // 用户管辖园区
  userGardenList: state => state.user.userGardenList,
  gardenAreaByStaff: state => state.user.gardenAreaByStaff,
  // 用户菜单
  userMunuList: state => state.user.userMunuList,
  // 用户昵称
  nickName: state => state.user.userData.nickName,
  // 用户ID
  staffId: state => state.user.userData.id,
  // 是否有派单权限 0:否 1:是
  isDispatch: state => state.user.userData.isDispatch,
  // 是否有关闭工单权限 0:否 1:是
  isClose: state => state.user.userData.isClose,

  isSetUp: state => state.user.userData.isSetUp,

  isFeeManager: state => state.user.userData.isFeeManager,

  isExamManager: state => state.user.userData.isExamManager,
  // 用户权限
  permission: state => state.user.userData.permission,
  // 车牌省份
  cityValue: state => state.car.cityValue,
  // 车牌城市
  carNum: state => state.car.carNum,
  // 收费减免按钮
  isRelationButton: state => state.user.isRelationButton,
  // 修改原始业主信息是否需要审核
  editPreInfoIsUseApprove: state => state.user.editPreInfoIsUseApprove,
}
export default getters
